import React from "react";
import { Controller } from "react-hook-form";
import {  Input, Label } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";

interface ControlledTextFieldProps {
  inputName: string;
  inputType: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: object;
  register?: any;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  isClear?: boolean;
  defaultValue?: string;
  className?: string;
  value?: string | FileList[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
  convertToNumber?: boolean;
}

type MyInputType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "tel"
  | "url"
  | "search"
  | "date"
  | "datetime-local"
  | "time"
  | "week"
  | "month"
  | "color"
  | "file";

const ControlledRowTextFieldForPortion: React.FC<ControlledTextFieldProps> = ({
  inputName,
  inputType,
  placeholder,
  invalid,
  control,
  rules,
  errors,
  register,
  isRequired,
  hasSideLabel,
  sideLabel,
  isDisabled,
  defaultValue,
  className,
  value,
  isClear,
  onChange,
  convertToNumber
}) => {
  return (
    <div className="my-1">

      <Label>Portion Price</Label>
      <Controller
        name={inputName}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Input
            id={inputName}
            type={inputType as MyInputType}
            placeholder={placeholder}
            invalid={invalid}
            disabled={isDisabled}
            {...field}
            value={field.value ?? ""}
            className={className}
            required={isRequired}
            step={inputType === "number" ? "any" : undefined}
            multiple={inputType === "file" ? true : undefined}
            onChange={(e) => {
              const value = e.target.value;
              field.onChange(convertToNumber && inputType === "number" ? +value : value);
              if (onChange) {
                onChange(e);
              }
            }}
          />
        )}
      />
      {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
      {invalid && (
        <ValidationMsgComponent
          inputName={inputName}
          invalid={invalid}
          errors={errors}
          rules={rules}
        />
      )}

    </div>
  );
};

export default ControlledRowTextFieldForPortion;
